/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

// Libs
import { toast } from "react-toastify";

// Components
import SelectInput from "components/SelectInput";
import Input from "components/Input";
import Button from "components/Button";
import ButtonInverted from "components/ButtonInverted";

// Services
import DashboardService from "services/dashboard";

// Constants
import { initialCustomerAnydesksValues, booleanStatusENUM } from "../../../../constants";

// Context
import { useGeneralProvider } from "contexts/general";

// Imgs
import CloseIconSvg from "assets/close-icon.svg";

// Styles
import {
  BackDrop,
  Container,
  HeaderContainer,
  HeaderText,
  HeaderCloseContainer,
  ImageWrapper,
  CloseIcon,
  BodyContainer,
  FooterContainer,
  InputGroup,
  InputLabel,
} from "./styles";

function EditCustomerAnydesk({
  setShowModal,
  selectedItem,
  handleCleanFilters,
  companyId,
}) {
  const { setLoading, globalUser } = useGeneralProvider();
  const userPassService = new DashboardService(globalUser);

  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [anydeskData, setAnydeskData] = useState({
    ...initialCustomerAnydesksValues,
    ...selectedItem,
  });

  useEffect(() => {
    handleEnableButtonSave();
  }, [anydeskData]);

  const handleUpdateAnydesk = () => {
    setLoading(true);

    userPassService
      .updateCompanyAnydesk({ companyId: companyId, ...anydeskData })
      .then(() => {
        toast.success("Anydesk atualizado com sucesso!");
        handleCleanFilters();
        setShowModal(false);
      })
      .catch((err) => {
        setLoading(false);

        if (err?.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Falha ao atualizar anydesk");
        }
      });
  };

  const handleEnableButtonSave = () => {
    let auxIsSaveEnabled = true;

    if (!anydeskData.anydeskName || !anydeskData.anydeskSerial || anydeskData.status === null) {
      auxIsSaveEnabled = false;
    }

    setIsSaveEnabled(auxIsSaveEnabled);
  };

  return (
    <BackDrop>
      <Container>
        <HeaderContainer>
          <HeaderCloseContainer>
            <ImageWrapper />
            <HeaderText>Editar Informações do anydesk</HeaderText>
            <ImageWrapper onClick={() => setShowModal(false)}>
              <CloseIcon src={CloseIconSvg} />
            </ImageWrapper>
          </HeaderCloseContainer>
        </HeaderContainer>

        <BodyContainer>
          <InputGroup>
            <InputLabel>Nome</InputLabel>
            <Input
              maxLength={255}
              value={anydeskData.anydeskName}
              onChange={(e) =>
                setAnydeskData({
                  ...anydeskData,
                  anydeskName: e.target.value,
                })
              }
            />
          </InputGroup>

          <InputGroup>
            <InputLabel>Serial</InputLabel>
            <Input
              maxLength={100}
              value={anydeskData.anydeskSerial.replace(/ /g,'')}
              onChange={(e) =>
                setAnydeskData({
                  ...anydeskData,
                  anydeskSerial: e.target.value.replace(/ /g,'')
                })
              }
            />
          </InputGroup>

          <InputGroup>
            <InputLabel>Situação</InputLabel>
            <SelectInput
              defaultOption={{ name: "Selecione...", id: null }}
              selectedOption={booleanStatusENUM.find(
                (item) => item.id === anydeskData.status
              )}
              optionLabel="name"
              optionValue="id"
              options={booleanStatusENUM}
              setSelectedOption={(e) => {
                setAnydeskData({
                  ...anydeskData,
                  status: e.id,
                });
              }}
            />
          </InputGroup>
        </BodyContainer>

        <FooterContainer>
          <ButtonInverted
            label={"cancelar"}
            onClick={() => setShowModal(false)}
          />
          <span />
          <Button
            label={"Salvar Alterações"}
            disabled={!isSaveEnabled}
            onClick={() => {
              handleUpdateAnydesk();
            }}
          />
        </FooterContainer>
      </Container>
    </BackDrop>
  );
}

export default EditCustomerAnydesk;
